import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { Profile } from 'profile-api';

@Component({
  selector: 'app-accept-invitation',
  templateUrl: './accept-invitation.component.html',
  styleUrls: ['./accept-invitation.component.css']
})
export class AcceptInvitationComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
  ) { }

  tokenValidationOk: boolean = true;
  tenderId: number;

  //ATTENTION: ACCEPT_INVITE_TICKET local storage is used only to avoid xxx to be called twice: 
  ngOnInit(): void {
    console.log("Accept invite ticket ngOnInit.");
    let tokenValid = localStorage.getItem('TOKEN_VALID');

    if (!tokenValid) {
        let token = null;

        this.route.queryParams.subscribe(params => {
            token = params['token'];
          });

        console.log("Token : " + token);
        if (token == null) {
          localStorage.setItem('TOKEN_VALID', 'false');
          this.tokenValidationOk = false;
          document.getElementById('windowMsg').innerHTML = "Token di conferma validazione invito non valido.";
          return;
        }
    
        this.commonService.getSharingService().sharingAcceptTokenPost(token).subscribe(
          (inviteResponse) => {
            this.tenderId = inviteResponse.tenderId;
            localStorage.setItem('TOKEN_VALID', 'true');
            this.tokenValidationOk = true;     
            console.log("Invitation acceptance confirmed");   
          },
          (error) => {   
            localStorage.setItem('TOKEN_VALID', 'false');     
            this.tokenValidationOk = false;
            document.getElementById('windowMsg').innerHTML = "Token di conferma validazione invito non valido.";
            console.log("Error = " + error);
          }
        );
    } else {
        this.tokenValidationOk = localStorage.getItem('TOKEN_VALID') === 'true' ? true : false;
        localStorage.removeItem('TOKEN_VALID');
    }

  }

  gotoTender() {
    this.commonService.getProfile().then( (profile: Profile) => {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'tenderDetail', "tenderId": this.tenderId } });
      }).catch(
        (error) => {
          console.log("User not logged in. Redirect to login")
          console.log(error);
          localStorage.setItem('TENDER_ID', this.tenderId.toString());
          this.router.navigate(['/login'], { queryParams: { "fromAcceptInvitation": 'yes' } });
        }
      );
  }

}
